import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { deletePerformanceKPI } from '../../../../store/apis/performanceService';

function DeleteModal({
  selectedKPI,
  selectedEmployee,
  refetchPerformanceDetails,
  isOpen,
  toggle,
}) {
  const { mutate: deletePerformance } = useMutation({
    mutationFn: deletePerformanceKPI,
    onSuccess: () => {
      toast.success('KPI deleted successfully!', {
        className: 'toast-success',
      });
      refetchPerformanceDetails();
    },
    onError: error => {
      toast.error(error?.message || 'Failed to delete KPI', {
        className: 'toast-error',
      });
    },
  });

  const onDelete = () => {
    const payload = {
      kpiCategory: selectedKPI?.KPI_Category,
      kpiSeq: selectedKPI?.KPI_Sequence,
      employeeId: selectedEmployee?.value,
    };
    deletePerformance(payload);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      modalClassName="custom-modal-size"
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader
        style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#101828',
        }}
        toggle={toggle}
      >
        Confirmation
      </ModalHeader>
      <ModalBody
        style={{ fontSize: '14px', fontWeight: '400', color: '#475467' }}
      >
        Are you sure you want to delete this KPI?
      </ModalBody>
      <ModalFooter className="modalFooter">
        <Button className="item custom-light-btn" onClick={toggle}>
          No
        </Button>
        <Button
          className="item"
          color="danger"
          onClick={() => {
            onDelete();
            toggle();
          }}
        >
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteModal;
